import Exam from "../images/exam.gif";
import Techion from "../images/Techion.gif"
import cam from "../images/cam.gif"
const Sdata = [
	{
		_id: "1",
		imgsrc: Exam,
		title: "Exam Portal",
		description:
			"Exam Portal were teachers can conduct there Exam in online for students",
		to: "https://exam-portal-2ee5f.web.app/signin",
	},
	{
		_id: "2",
		imgsrc: Techion,
		title: "Techion-21",
		description:
			"this website is to register for an events.which are conducted in Mca department",
		to: "https://techeon-21.web.app/",
	},
	{
		_id: "3",
		imgsrc: cam,
		title: "Photography",
		description: "this website is to book an event to shoot. or too take cam rents",
		to: "https://photography-cde34.web.app/",
	},
];

export default Sdata;
